import { WorkTrayView } from 'runtime/data/worktrayview';
import { WorkTrayPage } from 'runtime/data/worktraypage';
import { BulkActionInfo } from 'runtime/data/bulkactioninfo';

export class WorkTrayData {
    bulkActions: BulkActionInfo[];
    view: WorkTrayView;
    userSettings: string;
    initialPage: WorkTrayPage;
}